import { normalizedStringify } from "library/normalized-stringify/index.mjs"

export const TASK_COMPARISON_IGNORED_KEYS = new Set(["componentRef", "linkedFields"])

export function isIgnoredTaskComparisonKey(key) {
    return TASK_COMPARISON_IGNORED_KEYS.has(key)
}

export function normalizeTaskComparisonValue(value) {
    if (isFrequencyValue(value)) {
        return {
            interval: value.interval,
            period: value.period,
        }
    }

    return value
}

export function stringifyStandardTaskComparisonValue(value, options = {}) {
    const { preserveUnderscoreKeys = [], ignoreDollarKeys = false, normalizeString } = options
    const preservedUnderscoreKeySet = new Set(preserveUnderscoreKeys)

    return normalizedStringify(normalizeTaskComparisonValue(value), replaceValue)

    function replaceValue(key, currentValue) {
        if (isIgnoredTaskComparisonKey(key)) {
            return undefined
        }
        if (key.startsWith("_") && !preservedUnderscoreKeySet.has(key)) {
            return undefined
        }
        if (ignoreDollarKeys && key.startsWith("$")) {
            return undefined
        }
        if (typeof currentValue === "string" && normalizeString) {
            return normalizeString(currentValue)
        }
        return currentValue
    }
}

function isFrequencyValue(value) {
    return typeof value === "object" && value !== null && ("interval" in value || "period" in value)
}
